import { render, staticRenderFns } from "./ConfirmTransferModalSection.vue?vue&type=template&id=67b68e81&scoped=true"
import script from "./ConfirmTransferModalSection.vue?vue&type=script&lang=js"
export * from "./ConfirmTransferModalSection.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTransferModalSection.vue?vue&type=style&index=0&id=67b68e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b68e81",
  null
  
)

export default component.exports